import cx from 'classnames';
import { CalendarCheck, CarFront, Check, Coffee } from 'lucide-react';
import styles from './HowItWorks.module.css';

const steps = [
  {
    number: '01',
    Icon: CalendarCheck,
    title: 'Book online',
    description:
      'Pick the date and time that works for you. Our online scheduler takes less than two minutes.',
    meta: '\u2248 2 min'
  },
  {
    number: '02',
    Icon: Coffee,
    title: 'Drop off or stay',
    description:
      'Settle into our work-friendly lounge, or go about your day. Either way, we’ll text you updates and photos as work progresses.',
    meta: 'Wi-Fi \u00B7 Coffee \u00B7 Workspaces'
  },
  {
    number: '03',
    Icon: CarFront,
    title: 'Drive with confidence',
    description:
      'We’ll walk you through what was done and what to watch. No pressure, no upsell \u2014 just clear information.',
    meta: 'No surprises'
  }
];

export default function HowItWorks() {
  return (
    <section className="bg-canvas-default px-lg py-4xl md:px-2xl md:py-[96px]">
      <div className="mx-auto max-w-[1272px]">
        <div className="mx-auto max-w-[720px] text-center">
          <div className="mb-lg text-text-primary t-label-xs tracking-widest">
            HOW IT WORKS
          </div>
          <h2 className="mb-lg text-text-strong t-heading-3xl">
            We aim to drive you happy.
          </h2>
          <p className="text-text-default t-body-lg">
            Three simple steps — no paperwork shuffle, no guessing games, no
            awkward upsell at pickup.
          </p>
        </div>

        <div className="relative mt-3xl md:mt-[72px]">
          <div
            className={cx(
              'absolute hidden h-[2px] bg-border-subtle md:block',
              styles.connectorLine
            )}
          />

          <div className="relative grid grid-cols-1 gap-3xl md:grid-cols-3 md:gap-2xl">
            {steps.map(step => (
              <div
                key={step.number}
                className="relative flex flex-col items-center text-center"
              >
                <div className="relative mb-[28px]">
                  <div
                    className={cx(
                      'grid size-[80px] place-items-center rounded-full bg-background-primary text-text-inverse',
                      styles.stepCircle
                    )}
                  >
                    <step.Icon size={32} />
                  </div>
                  <div
                    className={cx(
                      'absolute grid size-[32px] place-items-center rounded-full text-text-strong',
                      styles.stepBadge
                    )}
                  >
                    {step.number}
                  </div>
                </div>

                <h3 className="mb-sm text-text-strong t-heading-lg">
                  {step.title}
                </h3>

                <p className="mb-lg max-w-[300px] text-text-default t-body-md">
                  {step.description}
                </p>

                <div
                  className={cx(
                    'inline-flex items-center gap-x-xs rounded-full bg-canvas-muted px-lg py-xs t-label-xs',
                    styles.metaPill
                  )}
                >
                  <Check size={12} color="#078843" />
                  {step.meta}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
